import React from "react";
import { Control } from "react-hook-form";

import { NoticeListSelect } from "../../form_components/NoticeListSelect";
import { NoticeFilters } from "../utils";

import css from "./SharedFilterGroups.module.scss";

export interface WorkflowFilterContentProps {
  control: Control<NoticeFilters, unknown>;
}

export function NoticeListFilterGroup({ control }: WorkflowFilterContentProps) {
  return (
    <div className={css.filterSection} aria-label="Notice lists filters">
      <NoticeListSelect
        name="noticeLists"
        label="Notices saved to"
        placeholder="Select list"
        control={control}
        mode="multiple"
        allowClear
        enablePortal
      />
    </div>
  );
}
